import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Questionnaire} from '@ngmedax/common-questionnaire-types';

import {configKeys} from '../thieme-catalog.config-keys';
import {AuthUriService} from './auth-uri.service';


/**
 * Api access to the questionnaire module of the instance. Copied subset of the
 * questionnaire-grid api service (not exported there), owned by this module.
 */
@Injectable()
export class ApiService {

  public constructor(
    private http: HttpClient,
    private authUriService: AuthUriService) {
  }

  /**
   * Method to load questionnaires (without questionnaire content)
   */
  public loadQuestionnaires(filter?: any, opts?: any): Promise<{rows: Questionnaire[], total: number}> {
    const baseUri = this.authUriService.buildUrl(configKeys.QUESTIONNAIRE_URI_CONFIG_KEY);
    const headers = this.authUriService.getAuthHeaders();

    const query: any = {filter: JSON.stringify(filter) || '{}', opts: JSON.stringify(opts) || '{}'};
    const basePath = `${baseUri}?${decodeURI(new URLSearchParams(query).toString())}`;

    return new Promise((resolve, reject) => {
      this.http.get(basePath, {headers})
        .subscribe((response: any) => {
            const questionnaires = response.questionnaire || response.rows || response;
            resolve({rows: questionnaires, total: response.total || 0});
          },
          error => {
            reject(error);
          });
    });
  }

  /**
   * Saves the questionnaire
   *
   * @returns {Promise<any>}
   */
  public saveQuestionnaire(questionnaire: Questionnaire): Promise<Questionnaire> {
    const payload = {
      $schema: 'questionnaire-schema.json',
      questionnaire: questionnaire,
    };

    payload.questionnaire.updatedAt = new Date().toJSON();

    if (!payload.questionnaire.createdAt) {
      payload.questionnaire.createdAt = new Date().toJSON();
    }

    const basePath = this.authUriService.buildUrl(configKeys.QUESTIONNAIRE_URI_CONFIG_KEY);
    const headers = this.authUriService.getAuthHeaders();

    return new Promise((resolve, reject) => {
      this.http.post(basePath, payload, {headers})
        .subscribe(
          () => resolve(questionnaire),
          error => reject(error));
    });
  }

  /**
   * Deletes the questionnaire by id
   *
   * @returns {Promise<any>}
   */
  public deleteQuestionnaire(questionnaireId: string): Promise<void> {
    const basePath = this.authUriService.buildUrl(configKeys.QUESTIONNAIRE_URI_CONFIG_KEY, `/${questionnaireId}`);
    const headers = this.authUriService.getAuthHeaders();

    return new Promise((resolve, reject) => {
      this.http.delete(basePath, {headers})
        .subscribe(
          () => resolve(),
          error => reject(error));
    });
  }
}
